export default "__VITE_ASSET__YIwanAOM__"